<template>
    <pm-simple-component-layout>

        <template slot="title">
            {{ $t('menu.settings') }}
        </template>

        <v-container id="main-settings">
            <div class="white" style="box-shadow: 0 0 5px rgba(0,0,0,.15); background: #fff; line-height: 1.2; margin: 10px 0 20px 0; padding: 0; overflow: hidden; border-radius: 10px; border: 0px solid #2979ff!important; ">

                <v-subheader
                    :key="i"
                    style="height: 80px; display: block; border-bottom: 4px double #aaa!important; padding: 15px 20px 0 20px; font-size: 16px; text-transform: uppercase; margin: 0;"
                    class="white"
                >
                    <small style="text-transform: none;" class="blue--text text--darken-3">{{ $t('settings.select_country') }}</small>
                    <div style="display: flex; position: relative; margin-top: -8px;">
                        <v-icon class="grey--text text--darken-2 text--accent-3" style="margin: 0 18px 0 2px;" v-text="'language'" />
                        <select style="width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" name="country" id="country"  @change="changeCountryNative" v-once>
                            <option v-for="opt in countries" :selected="opt.value === country" :value="opt.value">{{ opt.text }}</option>
                        </select>
                        <v-icon style="background: #fff; pointer-events: none; position: absolute; right: 0px; top: 14px; font-size: 28px;">arrow_drop_down</v-icon>
                    </div>
                </v-subheader>
                <div style="padding: 8px 20px 4px 20px;">
                    <div style="display: flex; position: relative;">
                        <v-icon style="margin: 0 18px 0 2px;" v-text="'comment_outline'" />
                        <select style="width: Calc(100% - 30px); padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" name="language" id="language" @change="changeLanguageNative" v-once>
                            <option v-for="opt in languages" :selected="opt.value === language" :value="opt.value">{{ opt.text }}</option>
                        </select>
                        <v-icon style="background: #fff; pointer-events: none; position: absolute; right: 0px; top: 14px; font-size: 28px;">arrow_drop_down</v-icon>
                    </div>

                    <div v-if="!['en', 'hu'].includes(language)" class="beta-language-notification" @click="$router.push('/feedback')">
                        <div class="pink lighten-2 white--text" style="text-align: center; font-size: 12px; border-radius: 7px; padding: 6px 12px; margin: 0 0 16px 0">
                            This translation is currently in beta. If you have any suggestions please <u style="font-weight: 600;">send us a feedback</u>.
                        </div>
                    </div>

                    <v-divider style="margin: 0;" />

                    <div style="display: flex; position: relative;">
                        <v-icon style="margin: 0 18px 0 2px;" v-text="'coin'" />
                        <select style="width: Calc(100% - 30px); padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" name="currency" id="currency"  @change="changeCurrencyNative" v-once>
                            <option v-for="opt in currencies" :selected="opt.value === currency" :value="opt.value">{{ opt.text }}</option>
                        </select>
                        <v-icon style="background: #fff; pointer-events: none; position: absolute; right: 0px; top: 14px; font-size: 28px;">arrow_drop_down</v-icon>
                    </div>

                    <v-divider style="margin: 0 0;" />

                    <div style="display: flex; position: relative;">
                        <v-icon style="margin: 0 18px 0 2px;" v-text="'tooth'" />
                        <select style="width: Calc(100% - 30px); padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" name="dentalNotations" id="dentalNotations" @change="changeNotationNative" v-once>
                            <option v-for="opt in dentalNotations" :selected="opt.value === dentalNotation" :value="opt.value">{{ opt.text }}</option>
                        </select>
                        <v-icon style="background: #fff; pointer-events: none; position: absolute; right: 0px; top: 14px; font-size: 28px;">arrow_drop_down</v-icon>
                    </div>

                    <template v-if="isDev">
                        <v-divider style="margin: 0 0;" />
                        <div style="display: flex; position: relative; justify-content: center;" @click="reload">
                            <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 15px 18px 0 2px;">mdiRestore</mdi>
                            <div style="text-transform: none; width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" v-once>
                                Reload
                            </div>
                        </div>
                    </template>

                        <v-divider style="margin: 0 0;" />
                        <div style="display: flex; position: relative; justify-content: center;" @click="$router.push('/advanced-settings')">
                            <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 15px 18px 0 2px;">mdiChevronRight</mdi>
                            <div style="text-transform: none; width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" v-once>
                                Advanced settings
                            </div>
                        </div>


                </div>

                 <!--v-subheader
                    style="height: 80px; display: block; border-top: 4px double #aaa!important; padding: 15px 20px 0 20px; font-size: 16px; text-transform: uppercase; margin: 0;"
                    class="white"
                >
                    <small style="text-transform: none;" class="blue--text text--darken-3">{{ $t('settings.theme') }}</small>
                    <div style="display: flex; margin-top: -8px;">
                        <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 14px 18px 0 2px;">palette</mdi>
                        <v-select
                            v-model="theme"
                            style="margin-top: -4px; text-transform: none;"
                            hide-details
                            :items="[{text: 'light', value: 'light'}, {text: 'dark', value: 'dark'}]"
                            menu-props="auto"
                            @change="changeTheme"
                        />
                    </div>
                </v-subheader-->
            </div>

            <!-- <div class="white" style="box-shadow: 0 0 5px rgba(0,0,0,.15); background: #fff; line-height: 1.2; margin: 10px 0 20px 0; padding: 0; overflow: hidden; border-radius: 10px; border: 0px solid #2979ff!important; ">
                <div style="display: block; padding: 15px 20px 0 20px; font-size: 16px; text-transform: uppercase; margin: 0;"
                    class="white"
                >
                    <small style="text-transform: none;" class="blue--text text--darken-3">Special settings</small>
                    <div style="display: flex; position: relative; margin-top: -8px;">
                        <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 14px 18px 0 2px;">mdiSpeedometer</mdi>
                        <select style="width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" name="transitionMode" id="transitionMode"  @change="changeTransitionMode" v-once>
                            <option :selected="transitionMode === 'full'" value="full">High quality transitions</option>
                            <option :selected="transitionMode === 'simplified'" value="simplified">Simplified transitions</option>
                        </select>
                        <v-icon style="background: #fff; pointer-events: none; position: absolute; right: 0px; top: 14px; font-size: 28px;">arrow_drop_down</v-icon>
                    </div>
                </div>
            </div> -->

            <pm-debug v-if="isDev && country === 'HU'" />

        </v-container>
        <pm-reset-cloud-dialog v-if="resetCloudDialog" v-model="resetCloudDialog" />

    </pm-simple-component-layout>
</template>

<style>
#main-settings .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
    display: none!important;
}
.v-menu__content.theme--light.menuable__content__active {
    background: #fff;
    max-height: 320px!important;
}
.v-select .v-input__append-inner .v-icon {
    font-size: 28px!important;
}
select {
    outline: none!important;
}
</style>

<script>

import theme from "../../configs/themes";

import PmSimpleComponentLayout from "@/components/core/pm-simple-component-layout";

import PmPriceListItem from "./pricelist-item";
import settingsService from "../../extensions/services/settings-service";
import getSettings from "../../configs/settings";
import getProtocols from "../../configs/protocols";
import PmResetCloudDialog from "./reset-cloud-dialog";
import PmDebug from "./debug.vue";
import {
    exchangeProtocolPrices,
    exchangeTreatmentPrices,
    translateProtocolTitles,
    translateTreatmentTitles,
    log,
    countryMap,
} from "@/extensions/services/pricelist-service";

export default {
    components: {
        // eslint-disable-next-line vue/no-unused-components
        PmSimpleComponentLayout,
        PmPriceListItem,
        PmResetCloudDialog,
        PmDebug,
    },

    data: () => {
        return ({
            step: 0,
            country: "US",
            language: app.$store.state.language,
            currency: app.$store.state.currency,
            dentalNotation: app.$store.state.dentalNotation || "ISO",
            dentalNotations: [],
            countryConfig: null,
            resetCloudDialog: false,
            cloudSyncRequired: false,
            theme: 'dark',
            release: location.hostname.includes("test.app.") ? 'test' : 'public',
            isDev: localStorage.getItem('isDevMode') === "true",
            deviceId: localStorage.getItem('deviceId') || 'Unknown device ID',
            transitionMode: localStorage.getItem('transitionMode') || 'full',
        });
    },
    created() {
        this.dentalNotations = this.getDentalNotations();

        this.language = this.$store.state.language;
        this.currency = this.$store.state.currency;
        this.dentalNotation = this.$store.state.dentalNotation || "ISO";
        const country = navigator.language.length > 2 ? navigator.language.slice(3, 5) : navigator.language;
        this.country = this.$store.state.localSettings.country || country.toUpperCase();
    },
    mounted() {

    },
    computed: {
        countries() {
            return settingsService.getCountries();
        },
        currencies() {
            return settingsService.getCurrencies();
        },
        languages() {
            return settingsService.getLanguages();
        },
    },
    beforeDestroy() {
        window.i18n.locale = this.$store.state.language;
    },
    beforeRouteLeave(to, from, next) {
        try {
            CloudSaveManager.saveSettings(this.$store.state.localSettings);
        } catch(error) {
            captureException(error);
        }
        next();
    },
    watch: {
        country() {
            // this.getSelectedCountryConfig();
            // this.setLanguageByCountry();
            // this.currency = this.$store.state.currency;
            // if (["US"].includes(this.country)) this.dentalNotation = "USA";
            // else if (["GB"].includes(this.country)) this.dentalNotation = "Palmer";
            // else this.dentalNotation = "ISO";
        },
        language() {
            window.i18n.locale = this.language;
            this.dentalNotations = this.getDentalNotations();
            // this.updateToolbar();
        },
    },
    methods: {
        reload() {
            window.location.reload();
        },
        changeTransitionMode(e) {
            this.transitionMode = e.target.value;
            localStorage.setItem('transitionMode', e.target.value);
        },
        changeCountryNative(e) {
            this.country = e.target.value;
            this.changeCountry();
        },
        changeNotationNative(e) {
            this.dentalNotation = e.target.value;
            this.changeNotation();
        },
        changeCurrencyNative(e) {
            this.currency = e.target.value;
            this.changeCurrency();
        },
        changeLanguageNative(e) {
            this.language = e.target.value;
            this.changeLanguage();
        },
        changeTheme() {
            window.theme = theme[this.theme];
            Vue.prototype.$theme = window.theme;
        },
        cloudSave() {
            this.resetCloudDialog = true;
        },
        async useDemo(force = false) {
            await this.$nextTick();

            const country = force ? this.country : settingsService.getDefaultCountry();
            const language = force ? this.language : settingsService.getDefaultLanguage();
            const currency = force ? this.currency : settingsService.getDefaultCurrency();
            const notation = settingsService.getDefaultNotation();
            const {settings: localSettings} = getSettings(country, language, currency);
            const {protocols} = getProtocols(country, language, currency);

            this.$store.state.localSettings = localSettings;
            this.$store.state.dentalStates = localSettings.dentalStates;
            this.$store.state.localSettings.protocols = protocols;
            this.$store.state.dentalNotation = notation;

            this.dentalNotation = notation;
            this.language = language;
            this.currency = currency;
            this.country = country;

            await this.save();

            if (!force) this.$bus.$emit("app.showSnackbar", {color: "blue", text: app.$t("settings.settings_saved"), timeout: 1500});

            if (typeof window.gtag === "function") {
                // eslint-disable-next-line no-undef
                gtag("event", "reset", {
                    "event_category": "settings",
                    "event_label": "Reset",
                });
            }
        },
        getDentalNotations() {
            return [
                {value: "ISO", text: app.$t("settings.dental_notation_iso")},
                {value: "USA", text: app.$t("settings.dental_notation_usa")},
                // {value: "Palmer", text: app.$t("settings.dental_notation_palmer")},
            ];
        },
        setLanguageByCountry() {
            this.language = "en";
            if (["IN"].includes(this.country)) return;
            const availableLanguages = [];
            this.languages.forEach((lang)=> {
                availableLanguages.push(lang.value);
            });
            // eslint-disable-next-line guard-for-in
            for (const i in this.countryConfig.languages) {
                const lang = this.countryConfig.languages[i];
                if (availableLanguages.includes(lang.iso639_1)) {
                    this.language = lang.iso639_1;
                    return;
                }
            }
        },
        getSelectedCountryConfig() {
            for (const i in window.CountryJson) {
                if (window.CountryJson[i].alpha2Code === this.country) {
                    this.countryConfig = window.CountryJson[i];
                    return;
                }
            }
        },
        async save() {
            this.saveData();

            await this.$nextTick();

            // this.$bus.$emit("app.showSnackbar", {color: "blue", text: app.$t("settings.settings_saved"), timeout: 1500});
        },
        saveData() {
            this.$store.state.language = this.language;
            this.$store.state.currency = this.currency;
            this.$store.state.dentalNotation = this.dentalNotation;
            this.$store.state.country = this.country;

            this.$store.state.localSettings.language = this.language;
            this.$store.state.localSettings.currency = this.currency;
            this.$store.state.localSettings.dentalNotation = this.dentalNotation;
            this.$store.state.localSettings.country = this.country;

            localStorage.setItem("settings", JSON.stringify(this.$store.state.localSettings));
            this.cloudSyncRequired = true;
        },
        translatePriceList() {
            translateProtocolTitles(this.language);
            translateTreatmentTitles(this.language);
        },
        exchangePriceList() {
            exchangeProtocolPrices(this.currency);
            exchangeTreatmentPrices(this.currency);
        },
        async changeCountry() {
            // ["US"].includes(this.country) ? "USA" : "ISO";
            const notation = countryMap.get(this.country) || countryMap.get("default");

            this.getSelectedCountryConfig();
            this.setLanguageByCountry();

            this.$store.state.localSettings.country = this.country;

            this.currency = settingsService.getDefaultCurrency();
            this.dentalNotation = notation;

            await this.$nextTick();

            this.translatePriceList();
            this.exchangePriceList();

            window.Tracker.logEvent({
                event_name: "change_country",
                event_category: "settings",
                event_label: this.country,
            });

            await this.save();
        },
        async changeCurrency() {
            this.exchangePriceList();

            window.Tracker.logEvent({
                event_name: "change_currency",
                event_category: "settings",
                event_label: this.currency,
            });

            await this.save();
        },
        async changeLanguage() {
            this.translatePriceList();

            window.Tracker.logEvent({
                event_name: "change_language",
                event_category: "settings",
                event_label: this.language,
            });

            await this.save();
        },
        async changeNotation() {
            window.Tracker.logEvent({
                event_name: "change_notation",
                event_category: "settings",
                event_label: this.dentalNotation,
            });

            await this.save();
        },
    },
};
</script>
